import React from 'react';
import * as routes from '../../resources/routes-name';
import { INavigateTo } from './interface';

export const navigationRef: React.RefObject<any> = React.createRef();

export const navigateTo = ({ pathname, state, search }: INavigateTo) => {
    if (!navigationRef.current) {
        return;
    }

    if (!pathname) {
        navigationRef.current.history.push(routes.ROUTE_HOME);
    }

    navigationRef.current.history.push({
        pathname,
        state: { ...state },
        search,
    });
}

export const navigateReplaceTo = ({ pathname, state = {}, search }: INavigateTo) => {
    if (!navigationRef.current) {
        return;
    }
    if (!pathname) {
        navigationRef.current.history.replace(routes.ROUTE_HOME);
    }
    navigationRef.current.history.replace({
        pathname: pathname,
        state: { ...state },
        search,
    });
};

export const windowNavigateReplaceTo = ({ pathname }: INavigateTo) => {
    if (!pathname) {
        return;
    }
    window.location.replace(pathname);
};